/*
 * @Author: changcheng
 * @LastEditTime: 2023-08-03 15:47:14
 */
import React, { useEffect, useState, useCallback } from "react";
import {
  Form,
  Input,
  Button,
  Table,
  Space,
  Select,
  Modal,
  message,
  Descriptions,
  TreeSelect,
} from "antd";
import {
  getVillageWaitReviewedList,
  updateUserInstituteStatus,
  queryApprovalInfo,
} from "@root/common/service";
import { RootState } from "@root/store/index";
import { useSelector } from "react-redux";
import "./_style1.scss";
import { subjectDic } from "@root/common/data/dic";
interface approvalInfoType {
  baseCenterCategoryList: string;
  baseHealthTitle: string;
  baseUserIdCategory: string;
  birthday: string;
  dataType: string;
  flowId: number;
  id: number;
  identityNumber: string;
  instituteId: number;
  nickName: string;
  sex: string;
  subjectId: number;
}
const { Option } = Select;
const baseAuditStatusArr = ["通过", "审核退回", "未确认"];
const flowTypeArr = ["注册", "调入", "修改"];
const SetExamineMethod = () => {
  const [form] = Form.useForm();
  const [list, setList] = useState([]);
  const [reason, setReason] = useState("");
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [isAddVisible, setIsAddVisible] = useState(false);
  const [approvalInfo, setApprovalInfo] = useState<approvalInfoType[]>([]);
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  /**
   * 判断是否是注册类型，用于区分数据展示
   */
  const [isRegisterType, setIsRegisterType] = useState(false);
  const {
    subjectData,
    titleData,
    instituteList = [],
    centerClassification = [],
  } = useSelector((state: any) => state.directionaries);
  const { baseUserCategory, instituteId, userId } = useSelector(
    (state: RootState) => state.userInfo
  );
  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
    console.log(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const columns = [
    {
      title: "审核状态",
      dataIndex: "baseAuditStatus",
      key: "baseAuditStatus",
      render: (_: any, record: any) => {
        return <span>{baseAuditStatusArr[_]}</span>;
      },
    },
    {
      title: "审核类型",
      dataIndex: "flowType",
      key: "flowType",
      render: (_: any, record: any) => {
        return <span>{flowTypeArr[_ - 1]}</span>;
      },
    },
    {
      title: "审核详情",
      dataIndex: "flowType",
      key: "flowType",
      render: (_: any, record: any) => {
        return (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <a
            onClick={() => {
              setIsRegisterType(record.flowType === "1" ? true : false);
              getApprovalInfo(record.id);
            }}
          >
            点击查看
          </a>
        );
      },
    },
    {
      title: "退回原因",
      dataIndex: "returnReason",
      key: "returnReason",
      render: (_: any, record: any) => {
        return <span>{_ ? _ : "无"}</span>;
      },
    },
    {
      title: "姓名",
      dataIndex: "nickName",
      key: "nickName",
    },
    {
      title: "性别",
      dataIndex: "sex",
      key: "sex",
      render: (_: any, record: any) => {
        return <span>{_ === "0" ? "男" : "女"}</span>;
      },
    },
    {
      title: "身份证号码",
      dataIndex: "identityNumber",
      key: "identityNumber",
    },
    {
      title: "手机号",
      dataIndex: "phonenumber",
      key: "phonenumber",
    },
    {
      title: "学科",
      dataIndex: "subjectId",
      key: "subjectId",
      render: (_: any, record: any) => {
        const item = subjectData.find((item: any) => item.id === _);
        return <span>{item ? item.name : ""}</span>;
      },
    },
    {
      title: "职称",
      dataIndex: "baseHealthTitle",
      key: "baseHealthTitle",
      render: (_: any, record: any) => {
        const item = titleData.find((item: any) => item.id === _);
        return <span>{item ? item.name : ""}</span>;
      },
    },
    {
      title: "操作时间",
      dataIndex: "updateTime",
      key: "updateTime",
    },
  ];
  /**
   * 获取审批详情
   * @param id
   */
  const getApprovalInfo = async (id: number) => {
    const { rows = [] } = await queryApprovalInfo(id);
    console.log(rows);

    setShowApprovalModal(true);
    setApprovalInfo(rows);
  };
  // 所在中心数据返现
  function GetbaseCenterCategoryList(
    centerClassification: any[],
    centerList: any[]
  ) {
    console.log("centerClassification", centerClassification);
    console.log("centerList", centerList);

    return centerList
      .map((item) => {
        return centerClassification.find((it) => it.id === Number(item)).name;
      })
      .join(",");
  }
  const queryWaitReviewedList = async (paramStr: string) => {
    console.log(paramStr);

    const { rows } = await getVillageWaitReviewedList(
      {
        pageNum: 1,
        pageSize: 1000,
      },
      baseUserCategory === "12"
        ? `${paramStr}&instituteId=${instituteId}`
        : baseUserCategory === "14"
        ? `${paramStr}&userId=${userId}`
        : paramStr
    );
    setList(
      rows.map((item: any) => {
        return {
          ...item,
          key: item.id,
        };
      })
    );
  };
  useEffect(() => {
    queryWaitReviewedList("");
  }, []);
  /**
   * 搜索待审核列表
   */
  const onFinish = (values: any) => {
    let str = "";
    for (let key in values) {
      if (values[key]) {
        str += `&${key}=${values[key]}`;
      }
    }
    queryWaitReviewedList(str);
  };
  /**
   * 更新用户审核状态
   */
  const updateExamineStatus = async ({
    userActionTypeEnum = "PASS",
    returnReason = "",
  }) => {
    const { code, msg } = await updateUserInstituteStatus({
      userActionTypeEnum,
      returnReason,
      list: selectedRowKeys,
    });
    if (code === 200) {
      message.success(`${msg}`);
    }
    await queryWaitReviewedList("");
  };

  const onReset = useCallback(() => {
    form.resetFields();
    queryWaitReviewedList("");
  }, [form]);

  const addCancel = useCallback(() => {
    setIsAddVisible(false);
  }, []);

  const handleOk = () => {
    console.log(reason);
    updateExamineStatus({ userActionTypeEnum: "RERURN", returnReason: reason });
    setIsAddVisible(false);
  };

  const changeReason = useCallback((e: any) => {
    setReason(e.target.value);
  }, []);

  const hasSelected = selectedRowKeys.length > 0;
  const [baseInfo, updateInfo] = approvalInfo;
  return (
    <div style={{ padding: "15px", background: "#fff" }}>
      <div className="top">
        <Form
          name="basic"
          initialValues={{
            baseAuditStatus: "",
            flowType: "",
            subjectId: "",
            baseHealthTitle: "",
          }}
          onFinish={onFinish}
          autoComplete="off"
          layout="inline"
          style={{
            display: "flex",
            flexWrap: "wrap",
          }}
          form={form}
        >
          <Form.Item label="审核状态" name="baseAuditStatus">
            <Select defaultValue="" style={{ width: 160 }}>
              <Option value="">请选择</Option>
              <Option value="0">通过</Option>
              <Option value="1">拒绝</Option>
              <Option value="2">未确认</Option>
            </Select>
          </Form.Item>

          <Form.Item label="审核类型" name="flowType">
            <Select defaultValue="" style={{ width: 160 }}>
              <Option value="">请选择</Option>
              <Option value="1">注册</Option>
              <Option value="2">调入</Option>
              <Option value="3">修改</Option>
            </Select>
          </Form.Item>
          <Form.Item label="学科" name="subjectId">
            <TreeSelect
              showSearch
              style={{ width: "100%" }}
              treeData={subjectDic}
              dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
              placeholder="请选择所在学科"
            />
          </Form.Item>
          <Form.Item label="职称" name="baseHealthTitle">
            <Select style={{ width: 160 }} defaultValue="">
              <Option value={""}>请选择</Option>
              {titleData.map((item: any, index: number) => {
                return (
                  <Option value={item.id} key={index}>
                    {item.name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
          <Form.Item label="姓名" name="nickName">
            <Input style={{ width: 160 }} />
          </Form.Item>
          <Form.Item label="证件号" name="identityNumber">
            <Input style={{ width: 160 }} />
          </Form.Item>
          <Form.Item label="手机号" name="phonenumber">
            <Input style={{ width: 160 }} />
          </Form.Item>

          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit">
                查询
              </Button>
              <Button type="primary" onClick={onReset}>
                重置
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </div>

      <div className="midBtn" style={{ display: "flex" }}>
        <Button
          type="primary"
          disabled={!hasSelected}
          onClick={() => {
            updateExamineStatus({ userActionTypeEnum: "PASS" });
          }}
        >
          审核通过
        </Button>
        <Button
          type="primary"
          disabled={!hasSelected}
          onClick={() => setIsAddVisible(true)}
        >
          审核退回
        </Button>
      </div>
      <Table
        bordered
        columns={columns}
        dataSource={list}
        size="middle"
        rowSelection={rowSelection}
        style={{
          marginTop: "10px",
        }}
      />

      <Modal
        title="退回修改"
        visible={isAddVisible}
        onCancel={addCancel}
        onOk={handleOk}
      >
        退回原因：
        <Input
          placeholder="请输入退回原因"
          style={{ width: 320 }}
          value={reason}
          onChange={changeReason}
        />
      </Modal>
      <Modal
        title="审批详情"
        visible={showApprovalModal}
        onOk={() => {
          setShowApprovalModal(false);
        }}
        onCancel={() => {
          setShowApprovalModal(false);
        }}
        width={"auto"}
      >
        {approvalInfo.length > 0 && (
          <Descriptions
            title={`用户信息${isRegisterType ? "" : "(原有/更改)"}`}
            bordered
          >
            <Descriptions.Item
              label="姓名"
              className={
                !isRegisterType && updateInfo.nickName !== null
                  ? "isUpdate"
                  : ""
              }
            >
              {baseInfo.nickName}
              {!isRegisterType &&
                updateInfo.nickName &&
                `->${updateInfo.nickName}`}
            </Descriptions.Item>
            <Descriptions.Item
              label="性别"
              className={
                !isRegisterType && updateInfo.sex !== null ? "isUpdate" : ""
              }
            >
              {baseInfo.sex === "0" ? "男" : "女"}
              {!isRegisterType &&
                updateInfo.sex &&
                `->${updateInfo.sex === "0" ? "男" : "女"}`}
            </Descriptions.Item>
            <Descriptions.Item
              label="证件类型"
              className={
                !isRegisterType && updateInfo.baseUserIdCategory !== null
                  ? "isUpdate"
                  : ""
              }
            >
              {baseInfo.baseUserIdCategory === "0" ? "身份证" : "其他"}
              {!isRegisterType &&
                updateInfo.baseUserIdCategory &&
                `->${
                  updateInfo.baseUserIdCategory === "0" ? "身份证" : "其他"
                }`}
            </Descriptions.Item>
            <Descriptions.Item
              label="证件号码"
              className={
                !isRegisterType && updateInfo.identityNumber !== null
                  ? "isUpdate"
                  : ""
              }
            >
              {baseInfo.identityNumber}
              {!isRegisterType &&
                updateInfo.identityNumber &&
                `->${updateInfo.identityNumber}`}
            </Descriptions.Item>
            <Descriptions.Item
              label="出生日期"
              className={
                !isRegisterType && updateInfo.birthday !== null
                  ? "isUpdate"
                  : ""
              }
            >
              {baseInfo.birthday}
              {!isRegisterType &&
                updateInfo.birthday &&
                `->${updateInfo.birthday}`}
            </Descriptions.Item>
            <Descriptions.Item
              label="职称"
              className={
                !isRegisterType && updateInfo.baseHealthTitle !== null
                  ? "isUpdate"
                  : ""
              }
            >
              {
                titleData.find(
                  (item: any) => item.id === Number(baseInfo.baseHealthTitle)
                )?.name
              }
              {!isRegisterType &&
                updateInfo.baseHealthTitle &&
                `->${
                  titleData.find(
                    (item: any) =>
                      item.id === Number(updateInfo.baseHealthTitle)
                  )?.name
                }`}
            </Descriptions.Item>
            <Descriptions.Item
              label="所在学科"
              className={
                !isRegisterType && updateInfo.subjectId !== null
                  ? "isUpdate"
                  : ""
              }
            >
              {
                subjectData.find((item: any) => item.id === baseInfo.subjectId)
                  ?.name
              }
              {!isRegisterType &&
                updateInfo.subjectId &&
                `->${
                  subjectData.find(
                    (item: any) => item.id === updateInfo.subjectId
                  )?.name
                }`}
            </Descriptions.Item>
            <Descriptions.Item
              label="所在中心"
              className={
                !isRegisterType && updateInfo.baseCenterCategoryList !== null
                  ? "isUpdate"
                  : ""
              }
            >
              {
                GetbaseCenterCategoryList(
                  centerClassification,
                  baseInfo.baseCenterCategoryList.split(",")
                )
                // centerClassification.find(
                //   (item) => item.id === Number(baseInfo.baseCenterCategoryList)
                // )?.name
              }
              {!isRegisterType &&
                updateInfo.baseCenterCategoryList &&
                `->${GetbaseCenterCategoryList(
                  centerClassification,
                  updateInfo.baseCenterCategoryList.split(",")
                )}`}
            </Descriptions.Item>
            <Descriptions.Item
              label="所在机构"
              className={
                !isRegisterType && updateInfo.instituteId !== null
                  ? "isUpdate"
                  : ""
              }
            >
              {
                instituteList.find(
                  (item: any) => item.id === baseInfo.instituteId
                )?.name
              }
              {!isRegisterType &&
                updateInfo.instituteId &&
                `->${
                  instituteList.find(
                    (item: any) => item.id === updateInfo.instituteId
                  )?.name
                }`}
            </Descriptions.Item>
          </Descriptions>
        )}
      </Modal>
    </div>
  );
};

export default SetExamineMethod;
